var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getPagina)?_c('div',{staticClass:"col-12",domProps:{"innerHTML":_vm._s(_vm.getHtml)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }